import { render, staticRenderFns } from "./DemoTextareaCounter.vue?vue&type=template&id=62ec04a8&"
import script from "./DemoTextareaCounter.vue?vue&type=script&lang=js&"
export * from "./DemoTextareaCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
